export function getPackageClassName(str = '') {
  return str.replace(/_/g, '-');
}

export default {
  getPackageClassName
};
